import React, { useEffect } from "react";
import { Button } from "../../shadcn/components/ui/button";
import { Input } from "../../shadcn/components/ui/input";
import ABLogoFooter from "../../icons/ABLogoFooter";
import TwitterSvg from "../../icons/socialmedia/TwitterSvg";
import FacebookSvg from "../../icons/socialmedia/FacebookSvg";
import InstagramSvg from "../../icons/socialmedia/InstagramSvg";
import YoutubeSvg from "../../icons/socialmedia/YoutubeSvg";
import LinkedinSvg from "../../icons/socialmedia/LinkedinSvg";
import ChevronDownSvg from "../../icons/ChevronDownSvg";
import ChevronUpSvg from "../../icons/ChevronUpSvg";
import { useRouter } from "next/router";
import { useState } from "react";
import { newsletterSubscription } from "services";
import { BetaForm as useBetaForm } from "@reusejs/react";
import { useSelector } from "react-redux";

interface PropertyList {
  title: string;
  value: string;
  children?: { title: string; href: string; value: string }[];
}

interface props {
  className?: string;
}

const propertyList: PropertyList[] = [
  {
    title: "Flats",
    value: "flats",
    children: [
      {
        title: "Chennai",
        value: "Chennai",
        href: process.env.NEXT_PUBLIC_AUCTION_BAZAAR_WEB_URL
          ? `${process.env.NEXT_PUBLIC_AUCTION_BAZAAR_WEB_URL}/residential-flat-auction-properties-in-chennai`
          : "/residential-flat-auction-properties-in-chennai",
      },
      {
        title: "Bangalore",
        value: "Bangalore",
        href: process.env.NEXT_PUBLIC_AUCTION_BAZAAR_WEB_URL
          ? `${process.env.NEXT_PUBLIC_AUCTION_BAZAAR_WEB_URL}/residential-flat-auction-properties-in-bangalore`
          : "/residential-flat-auction-properties-in-bangalore",
      },
      {
        title: "Pune",
        value: "Pune",
        href: process.env.NEXT_PUBLIC_AUCTION_BAZAAR_WEB_URL
          ? `${process.env.NEXT_PUBLIC_AUCTION_BAZAAR_WEB_URL}/residential-flat-auction-properties-in-pune`
          : "/residential-flat-auction-properties-in-pune",
      },
      {
        title: "Hyderabad",
        value: "Hyderabad",
        href: process.env.NEXT_PUBLIC_AUCTION_BAZAAR_WEB_URL
          ? `${process.env.NEXT_PUBLIC_AUCTION_BAZAAR_WEB_URL}/residential-flat-auction-properties-in-hyderabad`
          : "/residential-flat-auction-properties-in-hyderabad",
      },
      {
        title: "Kolkata",
        value: "Kolkata",
        href: process.env.NEXT_PUBLIC_AUCTION_BAZAAR_WEB_URL
          ? `${process.env.NEXT_PUBLIC_AUCTION_BAZAAR_WEB_URL}/residential-flat-auction-properties-in-kolkata`
          : "/residential-flat-auction-properties-in-kolkata",
      },
      {
        title: "Mumbai",
        value: "Mumbai",
        href: process.env.NEXT_PUBLIC_AUCTION_BAZAAR_WEB_URL
          ? `${process.env.NEXT_PUBLIC_AUCTION_BAZAAR_WEB_URL}/residential-flat-auction-properties-in-mumbai`
          : "/residential-flat-auction-properties-in-mumbai",
      },
      {
        title: "Jaipur",
        value: "Jaipur",
        href: process.env.NEXT_PUBLIC_AUCTION_BAZAAR_WEB_URL
          ? `${process.env.NEXT_PUBLIC_AUCTION_BAZAAR_WEB_URL}/residential-flat-auction-properties-in-jaipur`
          : "/residential-flat-auction-properties-in-jaipur",
      },
      {
        title: "Delhi",
        value: "Delhi",
        href: process.env.NEXT_PUBLIC_AUCTION_BAZAAR_WEB_URL
          ? `${process.env.NEXT_PUBLIC_AUCTION_BAZAAR_WEB_URL}/residential-flat-auction-properties-in-delhi`
          : "/residential-flat-auction-properties-in-delhi",
      },
    ],
  },
  {
    title: "Residential Properties",
    value: "residents",
    children: [
      {
        title: "Chennai",
        value: "Chennai",
        href: process.env.NEXT_PUBLIC_AUCTION_BAZAAR_WEB_URL
          ? `${process.env.NEXT_PUBLIC_AUCTION_BAZAAR_WEB_URL}/residential-auction-properties-in-chennai`
          : "/residential-auction-properties-in-chennai",
      },
      {
        title: "Bangalore",
        value: "Bangalore",
        href: process.env.NEXT_PUBLIC_AUCTION_BAZAAR_WEB_URL
          ? `${process.env.NEXT_PUBLIC_AUCTION_BAZAAR_WEB_URL}/residential-auction-properties-in-bangalore`
          : "/residential-auction-properties-in-bangalore",
      },
      {
        title: "Pune",
        value: "Pune",
        href: process.env.NEXT_PUBLIC_AUCTION_BAZAAR_WEB_URL
          ? `${process.env.NEXT_PUBLIC_AUCTION_BAZAAR_WEB_URL}/residential-auction-properties-in-pune`
          : "/residential-auction-properties-in-pune",
      },
      {
        title: "Hyderabad",
        value: "Hyderabad",
        href: process.env.NEXT_PUBLIC_AUCTION_BAZAAR_WEB_URL
          ? `${process.env.NEXT_PUBLIC_AUCTION_BAZAAR_WEB_URL}/residential-auction-properties-in-hyderabad`
          : "/residential-auction-properties-in-hyderabad",
      },
      {
        title: "Kolkata",
        value: "Kolkata",
        href: process.env.NEXT_PUBLIC_AUCTION_BAZAAR_WEB_URL
          ? `${process.env.NEXT_PUBLIC_AUCTION_BAZAAR_WEB_URL}/residential-auction-properties-in-kolkata`
          : "/residential-auction-properties-in-kolkata",
      },
      {
        title: "Mumbai",
        value: "Mumbai",
        href: process.env.NEXT_PUBLIC_AUCTION_BAZAAR_WEB_URL
          ? `${process.env.NEXT_PUBLIC_AUCTION_BAZAAR_WEB_URL}/residential-auction-properties-in-mumbai`
          : "/residential-auction-properties-in-mumbai",
      },
      {
        title: "Jaipur",
        value: "Jaipur",
        href: process.env.NEXT_PUBLIC_AUCTION_BAZAAR_WEB_URL
          ? `${process.env.NEXT_PUBLIC_AUCTION_BAZAAR_WEB_URL}/residential-auction-properties-in-jaipur`
          : "/residential-auction-properties-in-jaipur",
      },
      {
        title: "Delhi",
        value: "Delhi",
        href: process.env.NEXT_PUBLIC_AUCTION_BAZAAR_WEB_URL
          ? `${process.env.NEXT_PUBLIC_AUCTION_BAZAAR_WEB_URL}/residential-auction-properties-in-delhi`
          : "/residential-auction-properties-in-delhi",
      },
    ],
  },
  {
    title: "Commercial Properties",
    value: "commercials",
    children: [
      {
        title: "Chennai",
        value: "Chennai",
        href: process.env.NEXT_PUBLIC_AUCTION_BAZAAR_WEB_URL
          ? `${process.env.NEXT_PUBLIC_AUCTION_BAZAAR_WEB_URL}/commercial-auction-properties-in-chennai`
          : "/commercial-auction-properties-in-chennai",
      },
      {
        title: "Bangalore",
        value: "Bangalore",
        href: process.env.NEXT_PUBLIC_AUCTION_BAZAAR_WEB_URL
          ? `${process.env.NEXT_PUBLIC_AUCTION_BAZAAR_WEB_URL}/commercial-auction-properties-in-bangalore`
          : "/commercial-auction-properties-in-bangalore",
      },
      {
        title: "Pune",
        value: "Pune",
        href: process.env.NEXT_PUBLIC_AUCTION_BAZAAR_WEB_URL
          ? `${process.env.NEXT_PUBLIC_AUCTION_BAZAAR_WEB_URL}/commercial-auction-properties-in-pune`
          : "/commercial-auction-properties-in-pune",
      },
      {
        title: "Hyderabad",
        value: "Hyderabad",
        href: process.env.NEXT_PUBLIC_AUCTION_BAZAAR_WEB_URL
          ? `${process.env.NEXT_PUBLIC_AUCTION_BAZAAR_WEB_URL}/commercial-auction-properties-in-hyderabad`
          : "/commercial-auction-properties-in-hyderabad",
      },
      {
        title: "Kolkata",
        value: "Kolkata",
        href: process.env.NEXT_PUBLIC_AUCTION_BAZAAR_WEB_URL
          ? `${process.env.NEXT_PUBLIC_AUCTION_BAZAAR_WEB_URL}/commercial-auction-properties-in-kolkata`
          : "/commercial-auction-properties-in-kolkata",
      },
      {
        title: "Mumbai",
        value: "Mumbai",
        href: process.env.NEXT_PUBLIC_AUCTION_BAZAAR_WEB_URL
          ? `${process.env.NEXT_PUBLIC_AUCTION_BAZAAR_WEB_URL}/commercial-auction-properties-in-mumbai`
          : "/commercial-auction-properties-in-mumbai",
      },
      {
        title: "Jaipur",
        value: "Jaipur",
        href: process.env.NEXT_PUBLIC_AUCTION_BAZAAR_WEB_URL
          ? `${process.env.NEXT_PUBLIC_AUCTION_BAZAAR_WEB_URL}/commercial-auction-properties-in-jaipur`
          : "/commercial-auction-properties-in-jaipur",
      },
      {
        title: "Delhi",
        value: "Delhi",
        href: process.env.NEXT_PUBLIC_AUCTION_BAZAAR_WEB_URL
          ? `${process.env.NEXT_PUBLIC_AUCTION_BAZAAR_WEB_URL}/commercial-auction-properties-in-delhi`
          : "/commercial-auction-properties-in-delhi",
      },
    ],
  },
  {
    title: "Industrial Properties",
    value: "industrial",
    children: [
      {
        title: "Chennai",
        value: "Chennai",
        href: process.env.NEXT_PUBLIC_AUCTION_BAZAAR_WEB_URL
          ? `${process.env.NEXT_PUBLIC_AUCTION_BAZAAR_WEB_URL}/industrial-auction-properties-in-chennai`
          : "/industrial-auction-properties-in-chennai",
      },
      {
        title: "Bangalore",
        value: "Bangalore",
        href: process.env.NEXT_PUBLIC_AUCTION_BAZAAR_WEB_URL
          ? `${process.env.NEXT_PUBLIC_AUCTION_BAZAAR_WEB_URL}/industrial-auction-properties-in-bangalore`
          : "/industrial-auction-properties-in-bangalore",
      },
      {
        title: "Pune",
        value: "Pune",
        href: process.env.NEXT_PUBLIC_AUCTION_BAZAAR_WEB_URL
          ? `${process.env.NEXT_PUBLIC_AUCTION_BAZAAR_WEB_URL}/industrial-auction-properties-in-pune`
          : "/industrial-auction-properties-in-pune",
      },
      {
        title: "Hyderabad",
        value: "Hyderabad",
        href: process.env.NEXT_PUBLIC_AUCTION_BAZAAR_WEB_URL
          ? `${process.env.NEXT_PUBLIC_AUCTION_BAZAAR_WEB_URL}/industrial-auction-properties-in-hyderabad`
          : "/industrial-auction-properties-in-hyderabad",
      },
      {
        title: "Kolkata",
        value: "Kolkata",
        href: process.env.NEXT_PUBLIC_AUCTION_BAZAAR_WEB_URL
          ? `${process.env.NEXT_PUBLIC_AUCTION_BAZAAR_WEB_URL}/industrial-auction-properties-in-kolkata`
          : "/industrial-auction-properties-in-kolkata",
      },
      {
        title: "Mumbai",
        value: "Mumbai",
        href: process.env.NEXT_PUBLIC_AUCTION_BAZAAR_WEB_URL
          ? `${process.env.NEXT_PUBLIC_AUCTION_BAZAAR_WEB_URL}/industrial-auction-properties-in-mumbai`
          : "/industrial-auction-properties-in-mumbai",
      },
      {
        title: "Jaipur",
        value: "Jaipur",
        href: process.env.NEXT_PUBLIC_AUCTION_BAZAAR_WEB_URL
          ? `${process.env.NEXT_PUBLIC_AUCTION_BAZAAR_WEB_URL}/industrial-auction-properties-in-jaipur`
          : "/industrial-auction-properties-in-jaipur",
      },
      {
        title: "Delhi",
        value: "Delhi",
        href: process.env.NEXT_PUBLIC_AUCTION_BAZAAR_WEB_URL
          ? `${process.env.NEXT_PUBLIC_AUCTION_BAZAAR_WEB_URL}/industrial-auction-properties-in-delhi"`
          : "/industrial-auction-properties-in-delhi",
      },
    ],
  },
  {
    title: "Plots",
    value: "plots",
    children: [
      {
        title: "Chennai",
        value: "Chennai",
        href: process.env.NEXT_PUBLIC_AUCTION_BAZAAR_WEB_URL
          ? `${process.env.NEXT_PUBLIC_AUCTION_BAZAAR_WEB_URL}/commercial-plot-commercial-auction-properties-in-chennai`
          : "/commercial-plot-commercial-auction-properties-in-chennai",
      },
      {
        title: "Bangalore",
        value: "Bangalore",
        href: process.env.NEXT_PUBLIC_AUCTION_BAZAAR_WEB_URL
          ? `${process.env.NEXT_PUBLIC_AUCTION_BAZAAR_WEB_URL}/commercial-plot-commercial-auction-properties-in-bangalore`
          : "/commercial-plot-commercial-auction-properties-in-bangalore",
      },
      {
        title: "Pune",
        value: "Pune",
        href: process.env.NEXT_PUBLIC_AUCTION_BAZAAR_WEB_URL
          ? `${process.env.NEXT_PUBLIC_AUCTION_BAZAAR_WEB_URL}/commercial-plot-commercial-auction-properties-in-pune`
          : "/commercial-plot-commercial-auction-properties-in-pune",
      },
      {
        title: "Hyderabad",
        value: "Hyderabad",
        href: process.env.NEXT_PUBLIC_AUCTION_BAZAAR_WEB_URL
          ? `${process.env.NEXT_PUBLIC_AUCTION_BAZAAR_WEB_URL}/commercial-plot-commercial-auction-properties-in-hyderabad`
          : "/commercial-plot-commercial-auction-properties-in-hyderabad",
      },
      {
        title: "Kolkata",
        value: "Kolkata",
        href: process.env.NEXT_PUBLIC_AUCTION_BAZAAR_WEB_URL
          ? `${process.env.NEXT_PUBLIC_AUCTION_BAZAAR_WEB_URL}/commercial-plot-commercial-auction-properties-in-kolkata`
          : "/commercial-plot-commercial-auction-properties-in-kolkata",
      },
      {
        title: "Mumbai",
        value: "Mumbai",
        href: process.env.NEXT_PUBLIC_AUCTION_BAZAAR_WEB_URL
          ? `${process.env.NEXT_PUBLIC_AUCTION_BAZAAR_WEB_URL}/commercial-plot-commercial-auction-properties-in-mumbai`
          : "/commercial-plot-commercial-auction-properties-in-mumbai",
      },
      {
        title: "Jaipur",
        value: "Jaipur",
        href: process.env.NEXT_PUBLIC_AUCTION_BAZAAR_WEB_URL
          ? `${process.env.NEXT_PUBLIC_AUCTION_BAZAAR_WEB_URL}/commercial-plot-commercial-auction-properties-in-jaipur`
          : "/commercial-plot-commercial-auction-properties-in-jaipur",
      },
      {
        title: "Delhi",
        value: "Delhi",
        href: process.env.NEXT_PUBLIC_AUCTION_BAZAAR_WEB_URL
          ? `${process.env.NEXT_PUBLIC_AUCTION_BAZAAR_WEB_URL}/commercial-plot-commercial-auction-properties-in-delhi`
          : "/commercial-plot-commercial-auction-properties-in-delhi",
      },
    ],
  },
];

export default function Footer({ className }: props) {
  const router = useRouter();
  const isLoggedIn = useSelector((state: any) => state?.auth?.user);
  const [isSuccessModalOpen, setIsSuccessModalOpen] = useState(false);
  const [isErrorModalOpen, setIsErrorModalOpen] = useState(false);
  const [isDisclaimerExpanded, setIsDisclaimerExpanded] = useState(false);

  const form = useBetaForm({
    email: "",
  });

  const form_constraints = {
    email: {
      presence: {
        allowEmpty: false,
      },
      email: true,
    },
  };

  useEffect(() => {
    form.setValidationRules(form_constraints);
  }, []);

  const handleSubmit = async () => {
    try {
      if (form.validate()) {
        form.value.email = form.value.email?.trim()?.toLowerCase();
        const data: any = await newsletterSubscription(form.value);
        if (data) {
          setIsSuccessModalOpen(true);
          form.setField("email", "");
        }
      }
    } catch (error) {
      console.log("check here error", error);
    }
  };

  return (
    <>
      <div className={` w-full mt-4 lg:mt-20 ${className}`}>
        <div>
          {/* Help Section */}
          <div className="w-full px-4 lg:px-[124px]  2xl:w-[1245px] 2xl:mx-auto 2xl:px-0 translate-y-10">
            <div className="bg-brand-lightBlue px-4 lg:pl-[62px] lg:pr-20 lg:flex relative py-6 lg:pt-[67px] lg:pb-[63px] clip-path-bottomRightFooterMobile lg:clip-path-bottomRightTool">
              {/* Left part */}
              <div className="mid:w-[438px]">
                <p className="font-spaceGrotesk font-normal text-mobile-h3 lg:text-[40px] mid:text-web-h2 leading-[30px] lg:leading-[59px] text-brand-textBlack ">
                  NEED HELP IN BIDDING PROCESS?
                </p>
              </div>
              {/* Right part */}
              <div className="flex-1 mt-3 lg:mt-0 lg:ml-8 mid:ml-[73px]">
                <p className="font-openSans font-normal text-mobile-body-sm lg:text-web-body-lg leading-4 lg:leading-[21px] text-brand-textLightGrey">
                  {`Bank land auctions can be an excellent way to acquire valuable
                  land at a fair price. Auction property is a win-win proposal
                  for both banks and buyers. It's a great advantage for the
                  users to get the property at a discounted rate compared to the
                  market price`}
                </p>
                <div className="mt-5 lg:mt-[67px] flex gap-6 mobile:gap-4">
                  <Button
                    variant={"custom"}
                    size={"custom"}
                    onClick={() =>
                      router.push(
                        process.env.NEXT_PUBLIC_AUCTION_BAZAAR_WEB_URL
                          ? `${process.env.NEXT_PUBLIC_AUCTION_BAZAAR_WEB_URL}/contactus}`
                          : "/contactus",
                      )
                    }
                    className="h-9 w-[130px]  mobile:w-[170px] lg:h-auto lg:w-auto lg:px-14 lg:py-2.5 bg-brand-bgBlack"
                  >
                    <p className="font-openSans font-semibold text-mobile-body-sm lg:text-web-body-lg leading-4 lg:leading-7 text-white">
                      Talk to our expert
                    </p>
                  </Button>
                  <Button
                    variant={"custom"}
                    size={"custom"}
                    onClick={() =>
                      router.push(
                        process.env.NEXT_PUBLIC_AUCTION_BAZAAR_WEB_URL
                          ? `${process.env.NEXT_PUBLIC_AUCTION_BAZAAR_WEB_URL}/contactus}`
                          : "/contactus",
                      )
                    }
                    className="h-9 lg:h-auto w-[90px] mobile:w-[111px] lg:w-auto lg:px-14 lg:py-2.5 bg-transparent lg:bg-brand-bgBlack border lg:border-none border-brand-textLightGrey"
                  >
                    <p className="font-openSans font-semibold text-mobile-body-sm lg:text-web-body-lg leading-4 lg:leading-7 text-[#A8A8A8] lg:text-white ">
                      Chat Now
                    </p>
                  </Button>
                </div>
              </div>
            </div>
          </div>

          <div className="bg-brand-bgBlack">
            {/* Upper Container */}
            <div className="overflow-x-scroll  w-full px-customPaddingMobile lg:px-customPadding bg-brand-bgBlack pt-[78px] pb-7 lg:pt-[135px] lg:pb-[2px] 2xl:w-[1340px] 2xl:mx-auto 2xl:px-0">
              <div className="flex justify-between gap-7  ">
                {propertyList.map((item: any, index) => (
                  <ul
                    key={`property-${index}`}
                    className="space-y-4  text-nowrap"
                  >
                    {item?.children.map((city: any) => (
                      <li
                        key={city?.value}
                        className="font-openSans font-normal text-web-body-sm leading-4 text-[#A8A8A8] "
                      >
                        <a href={city?.href}>
                          {item.title} in {city?.title}
                        </a>
                      </li>
                    ))}
                  </ul>
                ))}
              </div>
            </div>

            {/* Lower Container */}
            <div className="flex flex-col lg:flex-row justify-between bg-brand-bgBlack pt-[42px] pb-4 lg:pt-[132px] px-customPaddingMobile lg:px-customPadding 2xl:w-[1340px] 2xl:mx-auto 2xl:px-0">
              {/* Logo */}
              <div className="flex items-center lg:block">
                <div
                  onClick={() =>
                    router.push(
                      process.env.NEXT_PUBLIC_AUCTION_BAZAAR_WEB_URL
                        ? `${process.env.NEXT_PUBLIC_AUCTION_BAZAAR_WEB_URL}/`
                        : "/",
                    )
                  }
                  className="cursor-pointer"
                >
                  <ABLogoFooter className="w-[140px] h-10 lg:h-auto lg:w-auto" />
                </div>
                <div className="flex gap-5 lg:mt-[53px] ml-auto">
                  <a href="https://twitter.com/Auctionbazaar_" target="blank">
                    <TwitterSvg className="h-4 w-4 lg:h-auto lg:w-auto" />
                  </a>
                  <a
                    href="https://www.linkedin.com/company/auctionbazaar"
                    target="blank"
                  >
                    <LinkedinSvg className="h-4 w-4 lg:h-auto lg:w-auto" />
                  </a>
                  <a
                    href="https://www.facebook.com/AuctionBazaardotcom"
                    target="blank"
                  >
                    <FacebookSvg className="h-4 w-4 lg:h-auto lg:w-auto" />
                  </a>
                  <a
                    href="https://www.instagram.com/auctionbazaar/"
                    target="blank"
                  >
                    <InstagramSvg className="h-4 w-4 lg:h-auto lg:w-auto" />
                  </a>
                  <a
                    href="https://www.youtube.com/@auctionbazaar5479"
                    target="blank"
                  >
                    <YoutubeSvg className="h-4 w-4 lg:h-auto lg:w-auto" />
                  </a>
                </div>
              </div>
              <div className="flex flex-col-reverse lg:flex-row flex-1 justify-between">
                {/* Middle */}
                <div className="mt-[42px] lg:mt-0 grid grid-cols-2 lg:grid-cols-3 gap-[60px] lg:mx-auto px-2">
                  {" "}
                  <div>
                    <p className="font-spaceGrotesk font-bold text-web-subheading leading-[23px] text-[#A8A8A8]">
                      COMPANY
                    </p>
                    <ul className="mt-[30px] space-y-4">
                      <li className="font-openSans font-normal text-web-body-sm leading-4 text-white">
                        <a
                          href={
                            process.env.NEXT_PUBLIC_AUCTION_BAZAAR_WEB_URL
                              ? `${process.env.NEXT_PUBLIC_AUCTION_BAZAAR_WEB_URL}/contactus`
                              : "/contactus"
                          }
                        >
                          Contact Us
                        </a>
                      </li>
                      <li className="font-openSans font-normal text-web-body-sm leading-4 text-white">
                        <a
                          href={
                            process.env.NEXT_PUBLIC_AUCTION_BAZAAR_WEB_URL
                              ? `${process.env.NEXT_PUBLIC_AUCTION_BAZAAR_WEB_URL}/aboutus`
                              : "/aboutus"
                          }
                        >
                          About
                        </a>
                      </li>
                      <li className="font-openSans font-normal text-web-body-sm leading-4 text-white">
                        <a
                          href={
                            process.env.NEXT_PUBLIC_AUCTION_BAZAAR_WEB_URL
                              ? `${process.env.NEXT_PUBLIC_AUCTION_BAZAAR_WEB_URL}/`
                              : "/"
                          }
                        >
                          Careers
                        </a>
                      </li>
                      {isLoggedIn && (
                        <li className="font-openSans font-normal text-web-body-sm leading-4 text-white">
                          <div
                            className="cursor-pointer"
                            onClick={() => {
                              if (window != undefined) {
                                if (
                                  !process.env
                                    .NEXT_PUBLIC_AUCTION_BAZAAR_WEB_URL
                                ) {
                                  window.location.href =
                                    process.env.NEXT_PUBLIC_BIDDER_URL || "";
                                }
                              }
                            }}
                          >
                            Bidding
                          </div>
                        </li>
                      )}
                    </ul>
                  </div>
                  <div>
                    <p className="font-spaceGrotesk font-bold text-web-subheading leading-[23px] text-[#A8A8A8]">
                      PROPERTIES
                    </p>
                    <ul className="mt-[30px] space-y-4">
                      <li className="font-openSans font-normal text-web-body-sm leading-4 text-white">
                        <a
                          href={
                            process.env.NEXT_PUBLIC_AUCTION_BAZAAR_WEB_URL
                              ? `${process.env.NEXT_PUBLIC_AUCTION_BAZAAR_WEB_URL}/residential-auction-properties`
                              : "/residential-auction-properties"
                          }
                        >
                          Residential
                        </a>
                      </li>
                      <li className="font-openSans font-normal text-web-body-sm leading-4 text-white">
                        <a
                          href={
                            process.env.NEXT_PUBLIC_AUCTION_BAZAAR_WEB_URL
                              ? `${process.env.NEXT_PUBLIC_AUCTION_BAZAAR_WEB_URL}/commercial-auction-properties`
                              : "/commercial-auction-properties"
                          }
                        >
                          Commercial
                        </a>
                      </li>
                      <li className="font-openSans font-normal text-web-body-sm leading-4 text-white">
                        <a
                          href={
                            process.env.NEXT_PUBLIC_AUCTION_BAZAAR_WEB_URL
                              ? `${process.env.NEXT_PUBLIC_AUCTION_BAZAAR_WEB_URL}/industrial-auction-properties`
                              : "/industrial-auction-properties"
                          }
                        >
                          Industries
                        </a>
                      </li>
                      <li className="font-openSans font-normal text-web-body-sm leading-4 text-white">
                        <a
                          href={
                            process.env.NEXT_PUBLIC_AUCTION_BAZAAR_WEB_URL
                              ? `${process.env.NEXT_PUBLIC_AUCTION_BAZAAR_WEB_URL}/private-properties`
                              : "/private-properties"
                          }
                        >
                          Private
                        </a>
                      </li>
                    </ul>
                  </div>
                  <div>
                    <p className="font-spaceGrotesk font-bold text-web-subheading leading-[23px] text-[#A8A8A8]">
                      QUICK LINKS
                    </p>
                    <ul className="mt-[30px] space-y-4">
                      <li className="font-openSans font-normal text-web-body-sm leading-4 text-white">
                        <a
                          href={
                            process.env.NEXT_PUBLIC_AUCTION_BAZAAR_WEB_URL
                              ? `${process.env.NEXT_PUBLIC_AUCTION_BAZAAR_WEB_URL}/blogs`
                              : "/blogs"
                          }
                        >
                          {" "}
                          Blogs
                        </a>
                      </li>
                      <li className="font-openSans font-normal text-web-body-sm leading-4 text-white">
                        <a
                          href={
                            process.env.NEXT_PUBLIC_AUCTION_BAZAAR_WEB_URL
                              ? `${process.env.NEXT_PUBLIC_AUCTION_BAZAAR_WEB_URL}/faq`
                              : "/faq"
                          }
                        >
                          FAQs
                        </a>
                      </li>
                      <li className="font-openSans font-normal text-web-body-sm leading-4 text-white">
                        <a
                          href={
                            process.env.NEXT_PUBLIC_AUCTION_BAZAAR_WEB_URL
                              ? `${process.env.NEXT_PUBLIC_AUCTION_BAZAAR_WEB_URL}/contactus`
                              : "/contactus"
                          }
                        >
                          Live Support
                        </a>
                      </li>
                    </ul>
                  </div>
                </div>
                {/* Newsletter */}
                <div className="mt-[42px]  lg:mt-0">
                  <p className="font-spaceGrotesk font-bold text-web-subheading leading-[23px] text-[#A8A8A8]">
                    SIGNUP FOR NEWS LETTER
                  </p>
                  <div className="relative border border-white rounded-lg w-full flex justify-between lg:w-[294px] mt-[25px]">
                    <Input
                      placeholder="Enter email"
                      value={form.getField("email")}
                      onChange={(e) => {
                        form.setField("email", e.target.value);
                      }}
                      className="bg-brand-bgBlack  outline-none px-2 rounded-lg w-full rounded-r-none  font-openSans font-normal text-web-body-sm leading-4 text-brand-textLightGrey"
                    />
                    <Button
                      onClick={handleSubmit}
                      className="text-brand-bgBlack bg-white rounded-md  hover:bg-white"
                    >
                      Submit
                    </Button>
                  </div>
                  {form.errors.get("email") ? (
                    <p className="mt-2 text-sm text-red-500">
                      {form.errors.get("email")[0]}
                    </p>
                  ) : null}
                </div>
              </div>

              <div className="lg:hidden border border-brand-textGrey mt-8" />
            </div>

            {/* Public Notice Aggregation Disclaimer */}
            <div className="w-full px-4 lg:px-[124px] 2xl:w-[1245px] 2xl:mx-auto 2xl:px-0 my-4">
              <div className="bg-brand-lightBlue px-4 lg:pl-[62px] lg:pr-20 relative py-6 lg:pt-[42px] lg:pb-[42px] clip-path-bottomRightFooterMobile lg:clip-path-bottomRightTool">
                <div className="flex items-start justify-between gap-4 mb-2 lg:mb-3">
                  <h3 className="font-spaceGrotesk uppercase font-normal text-mobile-subheading lg:text-[28px] leading-[23px] lg:leading-[38px] text-brand-textBlack flex-1">
                    Public Notice Aggregation Disclaimer
                  </h3>
                  <button
                    onClick={() =>
                      setIsDisclaimerExpanded(!isDisclaimerExpanded)
                    }
                    className="flex items-center justify-center p-2 lg:p-2.5 hover:bg-white/20 rounded-full transition-all duration-200 cursor-pointer flex-shrink-0 group"
                    aria-label={
                      isDisclaimerExpanded
                        ? "Collapse disclaimer"
                        : "Expand disclaimer"
                    }
                  >
                    {isDisclaimerExpanded ? (
                      <ChevronUpSvg
                        width={24}
                        height={24}
                        fill="#1A1A1A"
                        className="transition-transform duration-200 group-hover:scale-110"
                      />
                    ) : (
                      <ChevronDownSvg
                        width={24}
                        height={24}
                        fill="#1A1A1A"
                        className="transition-transform duration-200 group-hover:scale-110"
                      />
                    )}
                  </button>
                </div>
                <div className="relative">
                  <div
                    className={`overflow-hidden transition-all duration-500 ease-in-out ${
                      !isDisclaimerExpanded
                        ? "max-h-[100px] lg:max-h-[80px]"
                        : "max-h-[1000px]"
                    }`}
                  >
                    <div className="space-y-4 lg:space-y-5">
                      <p className="font-openSans font-normal text-mobile-body-sm lg:text-web-body-lg leading-4 lg:leading-[21px] text-brand-textLightGrey">
                        AuctionBazaar.com is an independent online marketplace
                        that aggregates and displays auction-related information
                        that is already available in the public domain through
                        statutory notices, lender publications, government
                        notifications, and other publicly accessible sources. We
                        do not claim any association, authorization, mandate, or
                        affiliation with any bank, financial institution, ARC,
                        NBFC, or lender unless expressly stated.
                      </p>
                      <p className="font-openSans font-normal text-mobile-body-sm lg:text-web-body-lg leading-4 lg:leading-[21px] text-brand-textLightGrey">
                        All information is hosted solely for informational and
                        bidder-awareness purposes, without any alteration to the
                        content of the public notice. AuctionBazaar.com does not
                        publish confidential, internal, or non-public documents
                        of any lender. The platform does not conduct auctions on
                        behalf of lenders unless formally appointed, and does
                        not guarantee the accuracy or completeness of the
                        information published in such public notices. Users are
                        advised to independently verify all auction details with
                        the concerned lender before participating in any auction
                        process. By using this platform, users acknowledge that
                        AuctionBazaar.com operates strictly as a public-domain
                        information aggregator, and not as an agent,
                        representative, or authorized partner of any lender,
                        unless specifically mentioned.
                      </p>
                    </div>
                  </div>
                  {!isDisclaimerExpanded && (
                    <div className="absolute bottom-0 left-0 right-0 h-12 bg-gradient-to-t from-brand-lightBlue to-transparent pointer-events-none" />
                  )}
                </div>
              </div>
            </div>

            {/* Terms and Conditions */}
            <div className="flex flex-col items-center  w-full  lg:flex-row-reverse bg-brand-bgBlack pt-0  lg:pt-6 pb-[42px] lg:pb-14 px-customPaddingMobile lg:px-customPadding 2xl:w-[1340px] 2xl:mx-auto 2xl:px-0">
              <div className="flex w-full max-w-[440px] lg:max-w-full lg:mx-0 mx-auto lg:w-auto justify-between gap-10 lg:ml-auto">
                <a
                  href={
                    process.env.NEXT_PUBLIC_AUCTION_BAZAAR_WEB_URL
                      ? `${process.env.NEXT_PUBLIC_AUCTION_BAZAAR_WEB_URL}/refundandcancellationpolicy`
                      : "/refundandcancellationpolicy"
                  }
                  className="font-openSans font-normal text-web-body-sm leading-4 text-brand-borderGrey lg:text-white  "
                >
                  Refund policy
                </a>
                <a
                  href={
                    process.env.NEXT_PUBLIC_AUCTION_BAZAAR_WEB_URL
                      ? `${process.env.NEXT_PUBLIC_AUCTION_BAZAAR_WEB_URL}/privacypolicy`
                      : "/privacypolicy"
                  }
                  className="font-openSans font-normal text-web-body-sm leading-4 text-brand-borderGrey lg:text-white  "
                >
                  Privacy Policy
                </a>
                <a
                  href={
                    process.env.NEXT_PUBLIC_AUCTION_BAZAAR_WEB_URL
                      ? `${process.env.NEXT_PUBLIC_AUCTION_BAZAAR_WEB_URL}/termsandconditions`
                      : "/termsandconditions"
                  }
                  className="font-openSans font-normal text-web-body-sm leading-4 text-brand-borderGrey lg:text-white  "
                >
                  Terms & Conditions
                </a>
              </div>
              <a
                href="/"
                className="font-openSans text-center  lg:text-start mt-4 px-5 lg:px-0 lg:mt-0 font-normal text-web-body-sm leading-4 text-brand-borderGrey lg:text-white "
              >
                © 2022 Auctionbazaar.com(ARCA EMART PVT LTD) All rights
                reserved.
              </a>
            </div>
          </div>
        </div>
      </div>
      {isSuccessModalOpen && (
        <div className="fixed inset-0 flex items-center justify-center z-50 bg-black bg-opacity-20">
          <div className="bg-white p-12 pt-4 pb-4 rounded-lg shadow-lg flex flex-col items-center space-y-4">
            <p className="font-openSans font-semibold text-mobile-body-md lg:text-web-body-lg leading-4  lg:leading-[30px]">
              {" "}
              Subscribed to Newsletter
            </p>

            <Button
              className="mt-4 px-4 py-0.5 bg-brand-bgBlack text-[12px] text-white rounded"
              onClick={() => setIsSuccessModalOpen(false)}
            >
              Close
            </Button>
          </div>
        </div>
      )}
      {isErrorModalOpen && (
        <div className="fixed inset-0 flex items-center justify-center z-50 bg-black bg-opacity-20">
          <div className="bg-white p-12 pt-8 pb-8 rounded-lg shadow-lg flex flex-col items-center space-y-4">
            <p className="font-openSans font-semibold text-mobile-body-md lg:text-web-body-lg leading-4  lg:leading-[30px]">
              {" "}
              Invalid Email
            </p>

            <Button
              className="mt-4 px-4 py-0.5 bg-brand-bgBlack text-[12px] text-white rounded"
              onClick={() => setIsErrorModalOpen(false)}
            >
              Close
            </Button>
          </div>
        </div>
      )}
    </>
  );
}
